import React, { useState } from 'react';
import { useCvData } from '../context/CvDataContext.js';
import './Sidebar.css';

const Sidebar = ({ onSkillClick }) => {
  const { personalInfo, contactInfo, skills, hobbies, loading, error, reload } = useCvData();
  const [showPhone, setShowPhone] = useState(false);

  const handlePhoneClick = () => {
    setShowPhone(true);
  };

  if (error) return (
    <aside className="sidebar">
      <p role="alert">{error.message || 'Failed to load.'}</p>
      <button onClick={reload} className="retry-btn">Retry</button>
    </aside>
  );
  if (loading) return (
    <>
      <div className="profile-section-mobile">
        <div className="profile-image">
          <div className="avatar">
            <div className="skeleton skeleton-circle" />
          </div>
        </div>
        <div className="skeleton skeleton-text lg" style={{ width: '60%', margin: '8px auto' }} />
        <div className="skeleton skeleton-text" style={{ width: '40%', margin: '8px auto' }} />
        <div className="profile-actions">
          <span className="skeleton" style={{ height: 36, width: 180, borderRadius: 8 }} />
        </div>
      </div>

      <aside className="sidebar">
        <div className="profile-section">
          <div className="profile-image">
            <div className="avatar">
              <div className="skeleton skeleton-circle" />
            </div>
          </div>
          <div className="skeleton skeleton-text lg" style={{ width: '60%' }} />
          <div className="skeleton skeleton-text" style={{ width: '40%' }} />
          <div className="profile-actions" style={{ marginTop: 12 }}>
            <span className="skeleton" style={{ height: 36, width: 200, borderRadius: 8 }} />
          </div>
        </div>

        <div className="mobile-header-spacer" aria-hidden="true"></div>

        <div className="contact-section">
          <h3>Contact</h3>
          {[...Array(4)].map((_, i) => (
            <div key={i} className="contact-item">
              <span className="skeleton" style={{ width: 20, height: 16, borderRadius: 4, marginRight: 8 }} />
              <span className="skeleton skeleton-text" style={{ width: '70%' }} />
            </div>
          ))}
        </div>

        <div className="skills-section">
          <h3>Coding Languages</h3>
          <div className="skill-tags">
            {[...Array(6)].map((_, i) => (
              <span key={i} className="skeleton" style={{ display: 'inline-block', width: 80, height: 28, borderRadius: 20 }} />
            ))}
          </div>

          <h3>Tech Stacks</h3>
          <div className="skill-tags">
            {[...Array(6)].map((_, i) => (
              <span key={i} className="skeleton" style={{ display: 'inline-block', width: 100, height: 28, borderRadius: 20 }} />
            ))}
          </div>

          <h3>Operating Systems</h3>
          <div className="skill-tags">
            {[...Array(5)].map((_, i) => (
              <span key={i} className="skeleton" style={{ display: 'inline-block', width: 90, height: 28, borderRadius: 20 }} />
            ))}
          </div>
        </div>

        <div className="hobbies-section">
          <h3>What else?</h3>
          <ul>
            {[...Array(4)].map((_, i) => (
              <li key={i} className="hobby-item">
                <span className="skeleton" style={{ width: 18, height: 16, borderRadius: 4, marginRight: 8 }} />
                <span className="skeleton skeleton-text" style={{ width: '50%' }} />
              </li>
            ))}
          </ul>
        </div>
      </aside>
    </>
  );
  return (
    <>
      {/* Fixed profile section for mobile */}
      <div className="profile-section-mobile">
        <div className="profile-image">
          <div className="avatar">
            <img
              className="avatar-img"
              src="/me/eli_elhadad.jpg"
              alt={personalInfo?.name || ''}
              onError={(e) => { e.currentTarget.style.display = 'none'; }}
            />
          </div>
        </div>
        <h1 className="name">{personalInfo?.name || ''}</h1>
        <p className="title">{personalInfo?.title || ''}</p>

        <div className="profile-actions">
          <a
            className="download-cv"
            href="/me/EliElhadad2025.pdf"
            download
            target="_blank"
            rel="noopener noreferrer"
            title="Download my CV as PDF"
          >
            <i className="fas fa-file-download" aria-hidden></i>
            <span>Download CV (PDF)</span>
          </a>
        </div>
      </div>

      <aside className="sidebar">
        <div className="profile-section">
          <div className="profile-image">
            <div className="avatar">
              <img
                className="avatar-img"
                src="/me/eli_elhadad.jpg"
                alt={personalInfo?.name || ''}
                onError={(e) => { e.currentTarget.style.display = 'none'; }}
              />
            </div>
          </div>
          <h1 className="name">{personalInfo?.name || ''}</h1>
          <p className="title">{personalInfo?.title || ''}</p>

          <div className="profile-actions">
            <a
              className="download-cv"
              href="/me/EliElhadad2025.pdf"
              download
              target="_blank"
              rel="noopener noreferrer"
              title="Download my CV as PDF"
            >
              <i className="fas fa-file-download" aria-hidden></i>
              <span>Download CV (PDF)</span>
            </a>
          </div>
        </div>

        {/* Spacer to ensure content starts below the fixed mobile profile */}
        <div className="mobile-header-spacer" aria-hidden="true"></div>

        {(contactInfo?.email || contactInfo?.phone || contactInfo?.whatsapp || contactInfo?.linkedin) && (
        <div className="contact-section">
        <h3>Contact</h3>
        {contactInfo?.email && (
          <div className="contact-item">
            <i className="fas fa-envelope"></i>
            <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
          </div>
        )}
        {contactInfo?.phone && (
          <div className="contact-item">
            <i className="fas fa-phone"></i>
            {showPhone ? (
              <a href={`tel:${contactInfo.phone}`}>{contactInfo.phone}</a>
            ) : (
              <span
                className="phone-reveal"
                onClick={handlePhoneClick}
              >
                Click to show
              </span>
            )}
          </div>
        )}
        {contactInfo?.whatsapp && (
          <div className="contact-item">
            <i className="fab fa-whatsapp"></i>
            <a href={`https://wa.me/${contactInfo.whatsapp.replace(/[^0-9]/g, '')}`} target="_blank" rel="noopener noreferrer">
              WhatsApp me
            </a>
          </div>
        )}
        {contactInfo?.linkedin && (
          <div className="contact-item">
            <i className="fab fa-linkedin"></i>
            <a href={contactInfo.linkedin} target="_blank" rel="noopener noreferrer">
              LinkedIn
            </a>
          </div>
        )}
      </div>
      )}

      {(skills.languages.length > 0 || skills.techStacks.length > 0 || skills.operatingSystems.length > 0) && (
      <div className="skills-section">
        {skills.languages.length > 0 && (<>
        <h3>Coding Languages</h3>
        <div className="skill-tags">
          {skills.languages.map((language, index) => (
            <span
              key={index}
              className="skill-tag clickable"
              onClick={() => onSkillClick && onSkillClick(language)}
              title={`Click to see companies where I used ${language}`}
            >
              {language}
            </span>
          ))}
        </div>
        </>)}

        {skills.techStacks.length > 0 && (<>
        <h3>Tech Stacks</h3>
        <div className="skill-tags">
          {skills.techStacks.map((tech, index) => (
            <span
              key={index}
              className="skill-tag clickable"
              onClick={() => onSkillClick && onSkillClick(tech)}
              title={`Click to see companies where I used ${tech}`}
            >
              {tech}
            </span>
          ))}
        </div>
        </>)}

        {skills.operatingSystems.length > 0 && (<>
        <h3>Operating Systems</h3>
        <div className="skill-tags">
          {skills.operatingSystems.map((os, index) => (
            <span
              key={index}
              className="skill-tag clickable"
              onClick={() => onSkillClick && onSkillClick(os)}
              title={`Click to see companies where I used ${os}`}
            >
              {os}
            </span>
          ))}
        </div>
        </>)}
      </div>
      )}

      {hobbies.length > 0 && (
      <div className="hobbies-section">
        <h3>What else?</h3>
        <ul>
          {hobbies.map((hobby, index) => (
            <li key={index} className="hobby-item">
              <i className={`hobby-icon ${getHobbyIcon(hobby)}`}></i>
              <span>{hobby}</span>
            </li>
          ))}
        </ul>
      </div>
      )}
      </aside>
    </>
  );
};

// Map hobby keywords to Font Awesome icons
const getHobbyIcon = (text) => {
  const t = (text || '').toLowerCase();
  if (t.includes('family')) return 'fas fa-heart';
  if (t.includes('music')) return 'fas fa-music';
  if (t.includes('martial')) return 'fas fa-fist-raised';
  if (t.includes('sci') || t.includes('fantasy')) return 'fas fa-rocket';
  return 'fas fa-star';
};

export default Sidebar;
